import { GridUtils } from '@/shared/util/grid-utils'

export const INCIDENT_TASK = {
    STILL_OPEN_AND_NOTIFIED_TO_ME: { code: 'STILL_OPEN_AND_NOTIFIED_TO_ME', url: 'stillOpenAndNotifiedToMe' },
    STILL_OPEN_AND_OPENED_BY_ME: { code: 'STILL_OPEN_AND_OPENED_BY_ME', url: 'stillOpenAndOpenedByMe' },
    CLOSED_AND_RELATED_TO_ME: { code: 'CLOSED_AND_RELATED_TO_ME', url: 'closedAndRelatedToMe' },
    RELATED_TO_ME: { code: 'RELATED_TO_ME', url: 'relatedToMe' },
    OPENED_BY_ME: { code: 'OPENED_BY_ME', url: 'openedByMe' }
}

export default {
    sideBarName: 'IncidentsSideBar',
    expanded: [
        {
            id: 'myIncidents',
            label: 'incidents.sidebar.incidents',
            icon: ['fal', 'file-alt'],
            hasChildren: true,
            children: [
                {
                    id: 'stillOpenAndNotifiedToMe',
                    label: 'incidents.sidebar.notifications',
                    icon: ['fal', 'envelope'],
                    filterModel: {},
                    uicomponent: 'uicomponent.incidents.filter.stillOpenAndNotifiedToMe',
                    task: INCIDENT_TASK.STILL_OPEN_AND_NOTIFIED_TO_ME
                },
                {
                    id: 'stillOpenAndOpenedByMe',
                    label: 'incidents.sidebar.openedIncidents',
                    icon: ['fal', 'exclamation-circle'],
                    uicomponent: 'uicomponent.incidents.filter.stillOpenAndOpenedByMe',
                    task: INCIDENT_TASK.STILL_OPEN_AND_OPENED_BY_ME
                },
                {
                    id: 'closedAndRelatedToMe',
                    label: 'incidents.sidebar.closedIncidents',
                    icon: ['fal', 'times-circle'],
                    filterModel: {},
                    uicomponent: 'uicomponent.incidents.filter.closedAndRelatedToMe',
                    task: INCIDENT_TASK.CLOSED_AND_RELATED_TO_ME
                },
                {
                    id: 'severities',
                    label: 'incidents.sidebar.severity',
                    hasChildren: true,
                    icon: ['fal', 'tachometer-fast'],
                    children: [] // updated dynamically
                },
                {
                    id: 'dates',
                    label: 'incidents.sidebar.dates',
                    hasChildren: true,
                    icon: ['fal', 'calendar-alt'],
                    children: [
                        {
                            id: 'openedByMeToday',
                            label: 'incidents.sidebar.today',
                            uicomponent: 'uicomponent.incidents.filter.openedByMe',
                            task: INCIDENT_TASK.OPENED_BY_ME,
                            filterModel: {
                                openingDate: GridUtils.getTodayDateFilterModel()
                            }
                        },
                        {
                            id: 'openedByMeThisWeek',
                            label: 'incidents.sidebar.thisWeek',
                            uicomponent: 'uicomponent.incidents.filter.openedByMe',
                            task: INCIDENT_TASK.OPENED_BY_ME,
                            filterModel: {
                                openingDate: GridUtils.getThisWeekDateFilterModel()
                            }
                        },
                        {
                            id: 'openedByMeThisMonth',
                            label: 'incidents.sidebar.thisMonth',
                            uicomponent: 'uicomponent.incidents.filter.openedByMe',
                            task: INCIDENT_TASK.OPENED_BY_ME,
                            filterModel: {
                                openingDate: GridUtils.getThisMonthDateFilterModel()
                            }
                        }
                    ]
                }
            ]
        }
    ],
    module: {
        icon: ['fal', 'exclamation-triangle'],
        name: 'entities.incident.incidentsManagement'
    }
}
